export const localeDateOptions = (date) => new Date(date).toLocaleDateString('ru-RU', {month: "long", day: "numeric"})

export const sleep = ms => new Promise(r => setTimeout(r, ms));

